//export const apiPort = "3000"
//export const apiRoot = "https://speechserver.experts7.com:" + apiPort + "/"

export const apiPort = "3000"
export const apiRoot = "https://api.experts7.com/"
export const server = "demoServer"